
<template>
  <div v-if="show"
       class="fixed z-10 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto flex items-center justify-center text-base">
    <div class="bg-white rounded-lg shadow-xl w-3/12 h-[36vh]">
      <div class="flex items-center justify-between p-4 border-b">
        <h4 class="text-lg text-gray-800 font-bold">Upload Inventory Items</h4>
        <button type="button"
                class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                @click="$emit('close')" aria-label="Close">
          <span class="sr-only">Dismiss</span>
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
               viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
        </button>
      </div>

      <div class="flex justify-center mt-6">
        <div class="w-full maACx-w-md flex flex-col space-y-4">
          <div>
            <label for="input1" class="block text-sm font-medium text-gray-700">
              <span class="text-red-500">*</span> Select Upload File <span class="text-sm text-green-700 cursor-pointer" @click="downloadTemplate">(Download Excel Template)</span>
            </label>
            <input
                id="input1"
                type="file"
                accept=".csv,.xlsx"
                @change="handleFileChange"
                class="w-full px-3 py-2 mt-3 text-sm bg-gray-100 border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Select File"
            />
            <p v-if="idError" class="text-red-500 text-sm mt-1">{{ idError }}</p>
          </div>
          <div>
            <CustomButton v-if="!isLoading" class="flex justify-center w-full text-center" label="Upload File"  @click.prevent="uploadFile" />
            <CustomButton v-else class="flex justify-center w-full text-center" label="Uploading..."  />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import apiClient from "@/services/api";

export default {
  name: "UploadInventoryItemsModal",
  components: {CustomButton},
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      file: null,
      idError: null,
      isLoading: false,
    };
  },
  methods: {
    async downloadTemplate() {
      try {
        const response = await apiClient.downloadInventoryItemsTemplate();
        if (!response.ok) {
          throw new Error(`Failed to download template: ${response.status} ${response.statusText}`);
        }
        let filename = 'inventory_items_template.xlsx';
        const disposition = response.headers.get('Content-Disposition');
        if (disposition) {
          const match = disposition.match(/filename="([^"]+)"/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const blob = await response.blob();
        const typedBlob = new Blob([blob], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(typedBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading template:', error);
        // $toast.error('Failed to download inventory template. Please try again.');
        throw error;
      }
    },
    handleFileChange(event) {
      const input = event.target;
      const selectedFile = input.files?.[0] || null;

      if (selectedFile) {
        // Validate file type
        const validTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (!validTypes.includes(selectedFile.type)) {

          this.idError = 'Please select a .csv or .xlsx file';
          this.file = null;
          this.input = ''; // Reset input
          return;
        }
        this.file = selectedFile;
      } else {
        this.file = null;
      }
    },
    async uploadFile() {
      if(!this.file) {
        this.$toast.error('Please upload a file');
        return;
      }
      const formData = new FormData();
      formData.append("file", this.file);
      try {
        this.isLoading = true;
        const response = await apiClient.uploadInventoryItems(formData);
        if (response.success) {
            this.isLoading = false;
            this.$toast.success(response.message);
            this.$emit('close');
        } else {
          this.isLoading = false;
          // Handle error (e.g., show an error message)
          console.error('Error uploading file:', response.message);
          // $toast.error('Failed to upload inventory items. Please try again.');
            this.$toast.error(response.message);
        }
        // Handle success (e.g., show a success message)
      } catch (error) {
        this.isLoading = false;
        console.error('Error uploading file:', error);
        this.$toast.error(error.message);
      }

    }
  }
}
</script>


<style scoped>

</style>